import { SUPPORT_PATH } from '/Router/routeConstants';

import { IRouteBeetle, IRouteCluster, IRouteLeaderboard, IRouteTeam, ITeamTitleParams } from './types';

export const basePath = {
  apps: '/apps/',
  beetle: `${SUPPORT_PATH}/beetle/`,
  leaderboards: `${SUPPORT_PATH}/leaderboards/`,
  teamLookup: `${SUPPORT_PATH}/teamslookup/`,
};

const removeUnderscoreType = (type?: string) => {
  return type?.replace(/_/g, ' ') ?? type;
};
export const createLeaderboardRoutes = ({ appName, env, id }: IRouteLeaderboard) => [
  {
    path: `${basePath.apps}${appName}${basePath.leaderboards}${env}`,
    breadcrumb: 'Leaderboards',
  },
  {
    path: `${basePath.apps}${appName}${basePath.leaderboards}${id}/${env}`,
    breadcrumb: id,
  },
];

export const createLookupRoutes = ({ appName, type, env, app, id }: IRouteBeetle, title?: string) => {
  const baseRoutePath = `${basePath.apps}${appName}${basePath.beetle}`;
  return [
    { path: baseRoutePath },
    {
      path: `${baseRoutePath}${type}/${env}`,
      breadcrumb: removeUnderscoreType(type),
    },
    {
      path: `${baseRoutePath}${type}/${env}/${app}/${id}`,
      breadcrumb: title ?? id,
    },
  ];
};
export const createClusterRoutes = (
  { type, env, appName, id, titleTask, runId, tab }: IRouteCluster,
  title?: string
) => {
  const baseRoutePath = `${basePath.apps}${appName}${basePath.beetle}`;
  return [
    { path: baseRoutePath },
    { path: `${baseRoutePath}${type}/${env}`, breadcrumb: removeUnderscoreType(type) },
    { path: `${baseRoutePath}${type}/${env}/${id}/${titleTask}`, breadcrumb: title ?? id },
    {
      path: `${baseRoutePath}${type}/${env}/${id}/${titleTask}/${runId}/${tab}`,
      breadcrumb: runId,
    },
  ];
};
export const createTeamLookupRoutes = (
  { type, env, appName, templateId, teamId }: IRouteTeam,
  title?: ITeamTitleParams
) => {
  const baseRoutePath = `${basePath.apps}${appName}${basePath.teamLookup}${env}`;

  return [
    { path: baseRoutePath, breadcrumb: 'Templates' },
    { path: `${baseRoutePath}/${templateId}`, breadcrumb: title?.templateName ?? templateId },
    {
      path: `${baseRoutePath}/${templateId}/${teamId}`,
      breadcrumb: title?.name ?? teamId,
    },
    {
      path: `${baseRoutePath}/${templateId}/${teamId}/${type}`,
      breadcrumb: type,
    },
  ];
};
